import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SwiperConfigInterface, SwiperDirective} from 'ngx-swiper-wrapper';
import {forkJoin, Subscription} from 'rxjs';
import {PagesService} from '../../../providers/services/pages.service';
import {StaticPage, StaticPageContent} from '../../../../config/config';
import {ApiService} from '../../../providers/services/api.service';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-homepage-sectors',
  templateUrl: './homepage-sectors.component.html',
  styleUrls: ['./homepage-sectors.component.scss']
})
export class HomepageSectorsComponent implements OnInit, OnDestroy {

  public readonly config: SwiperConfigInterface = {
    autoplay: false,
    loop: false,
    freeMode: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    breakpointsInverse: true,
    navigation: false,
    pagination: false,
    mousewheel: false,
    breakpoints: {
      768: {
        pagination: false
      },
      992: {
        breakpointsInverse: true,
        slidesPerView: 5,
        freeMode: false,
        pagination: false
      }
    }
  };

  items;
  staticContent;
  private subscriptions: Subscription = new Subscription();

  @ViewChild(SwiperDirective, {static: false}) swiper: SwiperDirective;

  constructor(private pagesServiceService: PagesService, private apiService: ApiService) {
    this.subscriptions.add(
      this.apiService.translateApi(
        locale => forkJoin([
          this.pagesServiceService.getApplicationsWithLocale(locale).pipe(map(({body}) => body.data.sectors)),
          this.pagesServiceService.getPageWithLocale(StaticPage.Homepage, locale).pipe(map(({body}) => body.data.contents[StaticPageContent[StaticPage.Homepage].sectors]))
        ])
      ).subscribe(([sectors, contents]) => {
        this.items = sectors;
        this.staticContent = contents;
        if (this.swiper) {
          this.swiper.update();
        }
      })
    );
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
